import styled from "styled-components"
import { colors, tabletSize, mobileSize } from "../../constants"
import TextInputBase from "./text-input-base"

export const Root = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "stretch"
})

export const FieldTitle = styled.span`
  height: 16px;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.light_black};
`

export const Red = styled.span`
  color: ${colors.bright_red};
`

export const ErrorMessage = styled(Red)`
  display: ${(props) => (props.show ? "block" : "none")};
  height: 15px;
  font-size: 13px;
  margin-top: 5px;
  @media (max-width: ${mobileSize}) {
    height: unset;
  }
`

export const NoSpaceErrorMessage = styled(Red)`
  display: ${(props) => (props.floatShow ? "block" : "none")};
  height: ${(props) => (props.floatShow ? "0" : "15px")};
  position: ${(props) => (props.floatShow ? "relative" : "unset")};
  top: ${(props) => (props.floatShow ? "5px" : "0")};
  margin-top: ${(props) => (props.floatShow ? "0" : "5px")};
  font-size: 13px;
  @media (max-width: ${tabletSize}) {
    position: static;
    margin-top: 5px;
    height: 5px;
  }
  @media (max-width: ${mobileSize}) {
    position: static;
    margin-top: 5px;
    height: 15px;
  }
`
